<template>
	<div class="app-container">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
					<el-breadcrumb-item>招聘需求发布</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<div class="form-div">
			<div class="title">
				<span>招聘需求发布信息</span>
				<hr />
			</div>
			<el-row class="box-title">
				<div class="box-title-img">
					<img src="@/assets/images/zpxqfb/qy.png" />
				</div>
				<div class="box-flex">
					企业信息
				</div>
			</el-row>
			<el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="right">
				<el-row>
					<el-col :span="10">
						<el-form-item label="申请人名称:" prop="entname">
							<span>{{form.entname}}</span>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="统一社会信用代码:" prop="uniscid">
							<span>{{form.uniscid}}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="所属区域:" prop="deptCode">
							<el-select v-model="form.deptCode" size="medium" clearable disabled>
								<el-option v-for="item in deptCodes" :key="item.deptCode" :label="item.shortName"
									:value="item.deptCode">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="是否注册山东高校毕业生就业信息网:" prop="isRegister" style="line-height: 1.25rem;">
							<el-radio-group v-model="form.isRegister">
								<el-radio label="Y" value="Y">是</el-radio>
								<el-radio label="N" value="N">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="15">
						<el-form-item label="工作地址:" prop="dom">
							<el-input v-model="form.dom" placeholder="请输入工作地址" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="15">
						<el-form-item label="企业简介:" prop="entIntroduction">
							<el-input type="textarea" :rows="3" placeholder="请输入企业简介" v-model="form.entIntroduction">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			<el-row class="box-title">
				<div class="box-title-img">
					<img src="@/assets/images/zpxqfb/zp.png" />
				</div>
				<div class="box-flex">
					招聘信息
				</div>
			</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="招聘形式:" prop="recruitmentForm">
							<el-select v-model="form.recruitmentForm" size="medium" clearable>
								<el-option v-for="item in recruitmentForms" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="岗位名称:" prop="postName">
							<el-input v-model="form.postName" placeholder="请输入岗位名称" clearable />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="需求专业:" prop="demandSpecialty">
							<el-input v-model="form.demandSpecialty" placeholder="请输入需求专业" clearable />
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="需求人数:" prop="demandNumber">
							<el-input-number v-model="form.demandNumber" placeholder="请输入需求人数" 
							controls-position="right" :min="1">
							</el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="薪资待遇:" prop="salary">
							<el-input v-model="form.salary" placeholder="请输入薪资待遇" clearable />
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="联系人:" prop="lxr">
							<el-input v-model="form.lxr" placeholder="请输入联系人" clearable />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="联系方式" prop="tel">
							<el-input v-model="form.tel" placeholder="请输入您的联系方式" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="15">
						<el-form-item label="岗位描述:" prop="jobDescription">
							<el-input type="textarea" :rows="8" placeholder="请输入岗位描述" v-model="form.jobDescription">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="15">
						<el-form-item label="备注:" prop="remark">
							<el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="form.remark">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="18" style="margin-top: 1.25rem;">
						<el-form-item>
							<div class="cn">
								我承诺：我所填写的发布内容及附件真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任。
							</div>
							<div class="btn">
								<el-button type="infor" @click="onSubmit('N')">保 存</el-button>
								<el-button type="primary" @click="onSubmit('Y')">提 交</el-button>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!--所有的该企业的暂存的子表数据-->
			<el-table v-loading="loading" :data="dataList" :border="true">
				<el-table-column label="序号" type="index" width="50">
				</el-table-column>
				<el-table-column label="招聘形式" align="center" prop="recruitmentForm" :show-overflow-tooltip="true" :formatter="recruitmentFormFormat"/>
				<el-table-column label="岗位名称" align="center" prop="postName" :show-overflow-tooltip="true"/>
				<el-table-column label="需求专业" align="center" prop="demandSpecialty" :show-overflow-tooltip="true"/>
				<el-table-column label="需求人数" align="center" prop="demandNumber" :show-overflow-tooltip="true"/>
				<el-table-column label="岗位描述" align="center" prop="jobDescription" :show-overflow-tooltip="true"/>
				<el-table-column label="薪资待遇" align="center" prop="salary" :show-overflow-tooltip="true"/>
				<el-table-column label="联系人" align="center" prop="lxr" :show-overflow-tooltip="true"/>
				<el-table-column label="联系方式" align="center" prop="tel" :show-overflow-tooltip="true"/>
				<el-table-column label="备注" align="center" prop="remark" :show-overflow-tooltip="true"/>
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
					<template slot-scope="scope">
						<el-button size="mini" type="text" icon="el-icon-edit" v-if="scope.row.ywSaveStatus=='N'" @click="handleUpdate(scope.row)">编辑
						</el-button>
						<el-button size="mini" type="text" icon="el-icon-delete" v-show="scope.row.ywSaveStatus=='N'" @click="handleDelete(scope.row)">删除
						</el-button>
						<el-button size="mini" type="text" icon="el-icon-s-promotion" v-show="scope.row.ywSaveStatus=='N'" @click="submitTjbsq(scope.row)">提交
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageNum" :page-size="queryParams.pageSize" :hide-on-single-page="true"
				:page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total"
				@pagination="getList">
			</el-pagination>
		</div>
	</div>

</template>

<script>
	import {listQyzpxxFb, addQyzpxx, getQyzpxx, delQyzpxx, updateQyzpxx} from "@/api/xwqy/qyzpxx";
	import {getOne} from "@/api/xwqy/qyjbxx";
	import {updatePvNum} from "@/api/itempv/pv";
	import {
		getListDept
	} from "@/api/system/dept"
	export default {
		name: 'zpxqfbForm',
		data() {
			return {
				loading: false,
				// 总条数
				total: 0,
				//table列表数据
				dataList:[],
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					ywSaveStatus:'N',
					uniscid:undefined
				},
				// 表单参数
				form: {
					entname: undefined,
					uniscid: undefined,
					deptCode: undefined,
					isRegister: undefined,
					dom: undefined,
					entIntroduction: undefined,
					qyjbxxRecid: undefined,
					recruitmentForm: undefined,
					postName: undefined,
					demandSpecialty: undefined,
					demandNumber: undefined,
					salary: undefined,
					lxr: undefined,
					tel: undefined,
					jobDescription: undefined,
					isZc: undefined,
					shType: undefined,
					ywFwjgRecid:undefined,
					ywSaveStatus:undefined,
				},
				rules: {
					entname: [{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur'
					}],
					uniscid: [{
						required: true,
						message: '请输入统一社会信用代码',
						trigger: 'blur'
					}],
					deptCode: [{
						required: true,
						message: '请选择所属区域',
						trigger: 'change'
					}],
					recruitmentForm: [{
						required: true,
						message: '请选择招聘形式',
						trigger: 'change'
					}],
					isRegister: [{
						required: true,
						message: '请选择是否注册山东高校毕业生几页信息网',
						trigger: 'change'
					}],
					dom: [{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}],
					entIntroduction: [{
						required: true,
						message: '请输入企业简介',
						trigger: 'blur'
					}],
					postName: [{
						required: true,
						message: '请输入岗位名称',
						trigger: 'blur'
					}],
					demandSpecialty: [{
						required: true,
						message: '请输入需求专业',
						trigger: 'blur'
					}],
					demandNumber: [{
						required: true,
						message: '请输入需求人数',
						trigger: 'blur'
					}],
					salary: [{
						required: true,
						message: '请输入薪资待遇',
						trigger: 'blur'
					}],
					lxr: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					tel: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}],
					jobDescription: [{
						required: true,
						message: '请输入岗位描述',
						trigger: 'blur'
					}],

				},
				deptCodes: [],
				recruitmentForms: [{
					value: '1',
					label: '就业'
				}, {
					value: '2',
					label: '实习'
				}],
				promise:false,
				recid: undefined,
				deptQueryParams:{
					deptLevel:'3',
					deptCode:'3710'
				},
				ywFwjgRecid:undefined
			}
		},
		created() {
			this.setFormValue();
			updatePvNum("xwqycz_rcdj_qyzpxxfb").then(response => {
				//pv 点击人才对接企业招聘信息发布
			});
			this.recid = this.$route.params && this.$route.params.recid;
			this.getDetail();
			this.getDeptList();
			
		},
		methods: {
			setFormValue(){
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if(ssessionLoginUser != null && ssessionLoginUser != undefined){
					this.loginUser = ssessionLoginUser.user;
					this.form.entname= this.loginUser.corname;
					this.form.uniscid = this.loginUser.cornumber;
					this.form.deptCode = this.loginUser.county;
					this.form.ywFwjgRecid = this.loginUser.ywFwjgRecid;
					this.form.dom = ssessionLoginUser.ywFwjg.dom;
					//----【】需要修改为recid
					this.ywFwjgRecid = this.loginUser.ywFwjgRecid;
					this.getList(this.loginUser.cornumber);
				}
			},
			getDetail(){
				if (this.recid != null && this.recid != undefined) {
					this.reset();
					const recid = this.recid;
					getQyzpxx(recid).then(response => {
						this.form = response.data;
					});
				}
			},
			// 表单重置
			reset() {
				this.form = {
					isRegister: undefined,
					dom: undefined,
					entIntroduction: undefined,
					qyjbxxRecid: undefined,
					recruitmentForm: undefined,
					postName: undefined,
					demandSpecialty: undefined,
					demandNumber: undefined,
					salary: undefined,
					lxr: undefined,
					tel: undefined,
					jobDescription: undefined,
					isZc: undefined,
					shType: undefined,
				};
				this.resetForm("form");
			},
			getDeptList() {
				getListDept(this.deptQueryParams).then(res => {
					this.deptCodes = res.data;
				})
			},
			onSubmit(flag){
				if (this.utils.isLoginTimeout()) {
					this.$refs["form"].validate(valid => {
						if (valid) {
							this.form.ywSaveStatus = flag;
							this.$confirm(`${flag=='N'?'是否保存？' : '是否提交？'}`, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.saveForm();
							})
						}
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
				
			},
			saveForm(){
				// console.log("this.form",this.form);
				if (this.form.recid != undefined) {
					updateQyzpxx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("成功");
							this.reset();
							this.setFormValue();
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				} else {
					addQyzpxx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("成功");
							this.reset();
							this.setFormValue();
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				}
				
			},
			//提交并申请
			submitTjbsq(row) {
				this.$confirm('是否提交并申请？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.form = row
					this.form.ywSaveStatus = 'Y'
					updateQyzpxx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("成功");
							this.reset();
							this.$router.back();
							this.getList();
						} else {
							this.msgError(response.msg);
						}
					});
				})
			},
			/** 修改按钮操作 */
			handleUpdate(row) {
				const recid = row.recid
				getQyzpxx(recid).then(response => {
					this.form = response.data;
				});
			},
			/** 删除按钮操作 */
			handleDelete(row) {
				const recids = row.recid;
				const postName = row.postName;
				this.$confirm('是否确认删除企业岗位名称为"' + postName + '"的数据项?', "警告", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(function() {
					return delQyzpxx(recids);
				}).then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				}).catch(function() {});
			},
			recruitmentFormFormat(row, column){
				let actions = [];
				let datas = this.recruitmentForms;
				let value = row.recruitmentForm;
				Object.keys(datas).map((key) => {
					if (datas[key].value == ('' + value)) {
						actions.push(datas[key].label);
						return false;
					}
				})
				return actions.join('');
			},
			getList(uniscid){
				// 
				this.queryParams.uniscid = uniscid;
				getOne(this.queryParams).then(res => {
					// console.log(res);
					this.queryParams.uniscid = undefined;
					if (res.data != null && res.data != undefined) {
						this.queryParams.qyjbxxRecid = res.data.recid;
						this.loading = true;
						listQyzpxxFb(this.queryParams).then(response => {
							// console.log(response)
							this.dataList = response.rows;
							this.total = response.total;
							this.loading = false;
						});
					}
				})
			},
			handleSizeChange(val) {
			    // console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
			    // console.log(`当前页: ${val}`);
			    this.getList();
			},
		}
	}
</script>

<style scoped="scoped">
	.app-container {
		padding: 0px 0.9375rem 1.25rem;
	}

	.navigation {
		padding: 1.25rem;
		line-height: 1.25rem;
		height: 3.75rem;
		background-color: #efefef;
	}

	.form-div {
		border: 0.0625rem solid #ebebeb;
		border-radius: 0.1875rem;
		transition: .2s;
		padding: 1.875rem 1.25rem;
		margin-top: 0.625rem;
		text-align: left !important;
		/* margin-bottom: 3rem; */
		/* padding-left: 1.25rem; */
	}

	.title {
		font-size: 1.125rem;
		font-weight: 700;
		color: #5b7bcd;
		padding-right: 1.25rem;
	}

	.form-div .box-title {
		display: flex;
		height: 3.5625rem;
		line-height: 3.125rem;
		font-size: 1.0625rem;
		padding-bottom: 0.4375rem;
	}

	.form-div .box-title img {
		width: 1.4375rem;
		height: 1.4375rem;
		margin: 0.625rem 0 0.8125rem;
	}

	.form-div .box-title .box-flex {
		flex: 1;
		padding-left: 0.625rem;
		text-align: left;
	}
	.cn {
		margin-bottom:1.875rem ;
		color: orangered;
	}
	.btn{
	    text-align: center ;
		margin-bottom: 1.875rem;
		
	}
	
</style>
